<!--
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-08-20 15:48:35
 * @LastEditTime: 2019-08-21 15:59:08
 * @LastEditors: Please set LastEditors
 -->
<template>
  <div>
    <!--<div class="end">-->
      <!--<div class="end1">-->
        <!--&lt;!&ndash;<div class="end1_img1 fl"><img src="@/assets/images/logo1.png"></div>&ndash;&gt;-->
        <!--&lt;!&ndash;<div class="end1_img2 fl"><img src="@/assets/images/er.png"></div>&ndash;&gt;-->
        <!--<div class="end2 fl">-->
          <!--&lt;!&ndash;<div class="fl"><img src="@/assets/images/end2.png" width="13" height="14"></div>&ndash;&gt;-->
          <!--<div>-->
            <!--<p style="font-size:12px; color:#d1d1d1; margin-left:33px; ">（+86）028-87030721 &nbsp;&nbsp;&nbsp;&nbsp; </p>-->

            <!--<p style="font-size:12px; color:#d1d1d1; margin-left:33px;  margin-top:10px;"> 四川省成都市武科西二路189号 </p>-->
          <!--</div>-->
        <!--</div>-->
        <!--<div class="end3 fl">-->
        <!--</div>-->
        <!--<div class="fl" style="margin:25px 33px 0 33px;"><a href="#"><img src="@/assets/images/h.png" width="45" height="39"></a></div>-->
      <!--</div>-->
    <!--</div>-->
    <div class="Footer">
      Copyright © 1992 - 2024 Ranken.All Rights Reserved &nbsp;&nbsp;
      <a target="_blank" href="https://beian.miit.gov.cn/">蜀ICP备11011248号-1</a>
    </div>
  </div>

</template>

<script>
export default {
  name: 'Footer',
  data () {
    return {
    }
  },
  methods: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.Footer{
  text-align: center;
  width: 980px;
  margin: 0px auto;
}
.fl {
  float: left;
}
.end {
  width: 100%;
  height: 92px;
  background: #1a478a;
  margin-top: 12px;
}

.end1 {
  width: 1200px;
  height: 92px;
  margin: 0 auto;
}

.end1_img1 {
  width: 81px;
  height: 25px;
  padding: 33px 25px;
}

.end1_img2 {
  width: 81px;
  height: 80px;
  padding: 6px 0;
}

.end2 {
  width: 470px;
  height: 30px;
  margin: 30px 125px;
}

.end3 {
  width: 20px;
  height: 50px;
  margin: 20px 60px;
}
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue